module.exports = __webpack_public_path__ + "static/media/visiretail.d5753098.svg";